import  React  from  'react';
import { GlobalProvider } from  './src/providers/GlobalProvider';

export  const  wrapRootElement = ({ element }) => {
  return <GlobalProvider>{element}</GlobalProvider>;
};